import {NamaKendoWindow, NamaWindowBtnData} from "../NamaKendoWindow";
import {translateId} from "../../common/Translator";
import {getCustomGUISettings} from "../../login/ClientCache";
import {InvItemCustomPanel} from "./InvItemCustomPanel";
import {ReferenceSelectorPopup} from "./SearcherWindow";

export class CustomItemSearcherWindow {
    constructor({owner, entityType, refSelectedCallBack, contextInfo, inChangeDimsDialog, defaultCriteria}) {
        this.owner = owner;
        this.entityType = entityType;
        this.refSelectedCallBack = refSelectedCallBack;
        this.contextInfo = contextInfo;
        this.inChangeDimsDialog = inChangeDimsDialog;
        this.defaultCriteria = defaultCriteria;
        this.allowRequests = true;
    }

    showPopup() {
        let that = this;
        let container = $(`<div><nav id="breadcrumb"></nav><div id="buttonsContainer"></div><div id ="customButtonsPart"></div><div id = "searching"></div></div>`);
        let dialog = new NamaKendoWindow(translateId(that.entityType), new NamaWindowBtnData("ok", () => dialog.closeWindow()), new NamaWindowBtnData("cancel"), "80%", false, true);
        that.dialog = dialog;
        let invItemCustomPanel = new InvItemCustomPanel(container, that, dialog);
        invItemCustomPanel.addBasicPanel(getCustomGUISettings().itemLevels);
        dialog.window.css("padding-top", 0);
        dialog.window.find("#listScreenFiltering").css("display", "none");
        let toNormalSearchBtn = $(`<button id = "toNormalSearch"></button>`);
        toNormalSearchBtn.attr("title", translateId("backToOldSearchUI"));
        dialog.window.find(".searcherWindowBtns").append(toNormalSearchBtn);
        toNormalSearchBtn.kendoButton({
            icon: "download",
            click: (e) => {
                toNormalSearchUI(that);
            }
        });
        let doNotCloseDiv = $(`<div>
        <input type='checkbox' id = "doNotCloseCheckBox" class="k-checkbox">
        <label class="k-checkbox-label" for="doNotCloseCheckBox">${translateId("doNotAutoCloseSearcherWindow")}</label></div>`);
        dialog.window.find(".searcherWindowBtns").prepend(doNotCloseDiv);
        let doNotAutoClose = doNotCloseDiv.find("#doNotCloseCheckBox");
        doNotAutoClose.prop("checked", localStorage.getItem("doNotAutoCloseSearcher") === "true");
        doNotAutoClose.change((e) => {
            e.preventDefault();
            localStorage.setItem("doNotAutoCloseSearcher", $(e.target).prop("checked"));
        });
        dialog.addDataWidget(container);
        dialog.showWindow(() => {
            invItemCustomPanel.setHeights();
        });
    }
}

export function toNormalSearchUI(currentSearcherWindow) {
    localStorage.removeItem("newSearchUI");
    currentSearcherWindow.dialog.closeWindow();
    new ReferenceSelectorPopup({
        owner: currentSearcherWindow.owner,
        entityType: currentSearcherWindow.entityType,
        refSelectedCallBack: currentSearcherWindow.callBack,
        contextInfo: currentSearcherWindow.contextInfo
        , inChangeDimsDialog: currentSearcherWindow.inChangeDimsDialog,
        defaultCriteria: currentSearcherWindow.defaultCriteria
    }).showPopup();
}

export function toNewSearchUI(currentSearcherWindow) {
    localStorage.setItem("newSearchUI", "true");
    currentSearcherWindow.kendowWindow.close();
    new CustomItemSearcherWindow({
        owner: currentSearcherWindow.owner,
        entityType: currentSearcherWindow.entityType,
        refSelectedCallBack: currentSearcherWindow.refSelectedCallBack,
        contextInfo: currentSearcherWindow.contextInfo
        , inChangeDimsDialog: currentSearcherWindow.inChangeDimsDialog,
        defaultCriteria: currentSearcherWindow.defaultCriteria
    }).showPopup();
}